<template>
  <div
    :class="{
      'chart-wrap': true,
      'chart-wrap-vertical': direction === 'vertical',
    }"
  >
    <div
      :class="{
        'chart-wrap-title': true,
        'chart-wrap-title-vertical': direction === 'vertical',
      }"
      @click="closeToolTip"
    >
      {{ $t('Internal_Tools_App_mZpF_DDAl' /** 价格趋势 */) }}
    </div>
    <div @click="closeToolTip">
      <FilterButton
        v-if="direction === 'vertical'"
        class="gas-filter-btn"
        after-icon="icon-outlinedpickup"
        :title="formatTitle()"
        @click="showDateRangePicker"
      />
    </div>
    <div class="chart-canvas-container">
      <div ref="wrap" class="chart-canvas" :style="{ height: height + 'PX' }"></div>
    </div>
    <div
      v-if="direction === 'vertical'"
      class="chart-canvas-btn"
      @click="showHor"
      @click.stop="showHor(chartkey)"
    >
      <i class="crm-quanping"></i>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import EventBus from './../utils/eventBus'
import FilterButton from '@/pages-v2/Gas/storeListGas/component/StoreFilter/components/filter-button.vue'
import dayjs from 'dayjs'
import { mapState, mapActions } from 'vuex'

const namespace = 'gasStore'
const min = dayjs(new Date().getTime() - 3600 * 1000 * 24 * 360).format('YYYY-MM-DD')
const max = dayjs(new Date().getTime() - 3600 * 1000 * 24).format('YYYY-MM-DD')
const start = dayjs(new Date().getTime() - 3600 * 1000 * 24 * 30).format('YYYY-MM-DD')

export default {
  components: {
    FilterButton,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    height: {
      type: Object,
      default: () => {},
    },
    chartkey: {
      type: String,
      default: '',
    },
    title: {
      type: Object,
      default: () => {},
    },
    direction: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
      config: {
        required: true,
        min: new Date(min),
        max: new Date(max),
        start: new Date(start),
        end: new Date(max),
        format: 'DD-MM-YYYY',
      },
      initTitle: `${start} - ${max}`,
      dates: [start, max],
    }
  },
  computed: {
    ...mapState(namespace, {
      product_type: state => state.params.product_type,
      station_id: state => state.params.station_id,
    }),
    chartOptions() {
      return this.options
    },
  },
  watch: {
    options(nVal, oVal) {
      if (nVal !== oVal) {
        if (this.direction === 'vertical') {
          this.init()
        } else {
          this.Horinit()
        }
      }
    },
  },
  mounted() {
    if (this.direction === 'vertical') {
      this.init()
    } else {
      this.Horinit()
    }
    // 接受到点击了其他区域的消息，隐藏图表的tooltip
    EventBus.$on('handleToolTipClose', message => {
      this.charts.dispatchAction({
        type: 'hideTip',
      })
    })
  },
  methods: {
    ...mapActions(namespace, ['updatePriceTrend']),
    showHor(chartKey) {
      this.closeToolTip()
      this.$emit('showHorCharts', chartKey)
    },
    // 用于通知图表点击了其他区域，隐藏图表的tooltip
    closeToolTip() {
      EventBus.$emit('handleToolTipClose', '')
    },
    chooseMode(index) {
      if (this.currentMode !== index) {
        this.currentMode = index
        this.init()
      }
    },
    formatTitle() {
      const { start_date, end_date } = this.title
      if (start_date && end_date) {
        /** 设置时间选择器起始、终止时间 */
        this.config.start = new Date(start_date)
        this.config.end = new Date(end_date)
        return `${this.formatDateTimeShow(start_date)} - ${this.formatDateTimeShow(end_date)}`
      } else {
        return `${this.formatDateTimeShow(start)} - ${this.formatDateTimeShow(max)}`
      }
    },
    Horinit() {
      setTimeout(() => {
        if (!this.charts) {
          this.charts = echarts.init(this.$refs.wrap)
        }
        if (this.chartOptions) {
          // 必须clear, 否则图表切换tooltip展示有问题
          this.charts.clear()
          this.charts.setOption(this.chartOptions)
          this.charts.resize()
        }
      }, 0)
    },
    init() {
      if (!this.charts) {
        this.charts = echarts.init(this.$refs.wrap)
      }
      if (this.chartOptions) {
        this.charts.setOption(this.chartOptions)
      }
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },
    formatDateTimeShow(date) {
      return dayjs(date).format('DD-MM-YYYY')
    },
    showDateRangePicker() {
      this.pickerInstance = <rich-date-range-picker options={this.config} />
      this.floating = this.$Floating({
        type: 'floating',
        title: this.$t('Internal_Tools_App_mzyX_fryx' /** 选择时间 */),
        content: (
          <div>
            <div class="select-time-tip">
              {this.$t('Internal_Tools_App_UIXX_nKyD' /** 最大支持在360天的时间跨度内筛选 */)}
            </div>
            {this.pickerInstance}
            <rich-button class="date-range-picker-btn" onClick={this.onOk}>
              {this.$t('Internal_Tools_App_oOXF_fLkh' /** 确认 */)}
            </rich-button>
          </div>
        ),
        destroy: true,
      })
    },
    onOk() {
      this.dates = this.pickerInstance.componentInstance.doPick()
      const min = 3600 * 1000 * 24 * 1
      const max = 3600 * 1000 * 24 * 30
      const interval = this.dates[1] - this.dates[0]
      /** 单次选择时间区间需要在2-30天 */
      if (interval < min) {
        this.$createToast({
          txt: this.$t('Internal_Tools_App_BEnH_Yxgl' /** 最小查询时间是2天 */),
          type: 'txt',
        }).show()
      } else if (interval > max) {
        this.$createToast({
          txt: this.$t('Internal_Tools_App_xIAG_xcRt' /** 最大查询时间是30天 */),
          type: 'txt',
        }).show()
      } else {
        this.updatePriceTrend({
          product_type: this.product_type,
          station_id: this.station_id,
          start_date: this.formatDate(this.dates[0]),
          end_date: this.formatDate(this.dates[1]),
        })
        this.floating.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-wrap {
  background: #ffffff;
  border-radius: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 32px 28px 32px;
  &-vertical {
    margin-top: 20px;
  }
  .chart-wrap-title {
    text-align: left;
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 700;
    &-vertical {
      margin-bottom: 36px;
    }
  }
  .gas-filter-btn {
    width: fit-content;
    max-width: 392px;
    background: #f5f5f5;
  }
}
.chart-canvas {
  position: relative;
  margin-top: 32px;
}
.chart-canvas-btn {
  position: absolute;
  width: 46px;
  height: 46px;
  right: 32px;
  opacity: 0.6;
  background: #000000;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .crm-quanping {
    width: 18px;
    height: 18px;
    font-size: 18px;
    color: #ffffff;
  }
}
.date-range-picker-btn {
  margin-bottom: 40px;
}
.select-time-tip {
  text-align: center;
  font-family: DiDiSans-Pro-Regular;
  font-size: 24px;
  color: #595c66;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  font-weight: 400;
}
</style>
